module.exports = __webpack_public_path__ + "static/media/doug@3x.d53de8ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/doug@3x.png
// module id = 215
// module chunks = 1